// extracted by mini-css-extract-plugin
export default {"addItem":"ParticipantSettings_addItem_i_Juj","spinAround":"ParticipantSettings_spinAround_AN9dw"};